export default __webpack_public_path__ + "static/media/background.25cc8a62.png";